<section class="content">
  <div class="card" style="padding: 24px;">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-1"></div>
      <div class="col-3">
        <input type="date" [min]="min_date" [(ngModel)]="selected_date" class="main-border-class" [max]="max_date" />
      </div>
      <div class="col-3">
        <mat-select class="main-border-class" [(ngModel)]="selected_session_id">
          <mat-option *ngFor="let session of session_list" [value]="session['id']">{{session['name']}}
          </mat-option>
        </mat-select>
      </div>
      <div class="col">
        <button (click)="getClicked()" style="font-size: 27px;border-radius: 5px;background: blanchedalmond;"
          [disabled]="checkDisable()">Get</button>
      </div>
    </div>
    <mat-card style="margin-top: 28px;" *ngIf="res_data != null">

      <div
        style="background-color: gainsboro;color:#060606;text-align: center; padding: 10px; border-radius: 9px; margin-top: 19px;">
        <h3 style="font-weight: normal;">Sale Summary for <br>
          <span style="color:brown">{{res_data['date'] | date: 'EEEE' }}</span><span
            style="font-size: 17px;">({{res_data['date'] | date: 'dd-MMM' }}) </span> <span
            style="color: #694eb7; font-weight: 500;"> {{res_data['session']}} </span> Routes</h3>
      </div>
      <div class="row" style="padding: 10px; font-size: 15px; color: slategray;">
        <div class="col-3">
          Orders :
        </div>
        <div class="col-3">
          Routes :
        </div>
        <div class="col-3">
          Business :
        </div>
      </div>
      <div class="row" style="padding: 0px; margin-left:0px; margin-top: -3px;">
        <div class="col-3" style="font-size: 15px;">
          <span *ngFor="let product_type of product_types">
            {{product_type}} : <b style="font-weight: 500;">
              {{res_data['product_group_wise'][product_type]['count'] | number:'1.0-3'}}
              {{res_data['product_group_wise'][product_type]['unit']}} </b><br>
          </span>
        </div>
        <div class="col-3" style="font-size: 15px;">
          <span>All : <b style="font-weight: 500;"> {{overall_indent['route_count']}}</b> <br></span>
          <span>Has Order : <b style="font-weight: 500;"> {{overall_indent['ordered_route_count']}}</b> <br></span>
          <span>Closed : <b style="font-weight: 500;">{{overall_indent['closed_route_count']}}</b> <br></span>
        </div>
        <div class="col-3" style="font-size: 15px;">
          <span>Active : <b style="font-weight: 500;"> {{overall_indent['business_count']}}</b> <br></span>
          <span>Ordered : <b style="font-weight: 500;"> {{overall_indent['ordered_business_count']}}
              ({{ calculate_percent(overall_indent['ordered_business_count'], overall_indent['business_count']) }}
              %)</b> <br></span>
        </div>
        <div class="col-3" style="font-size: 15px;">
          <button style="border-radius: 10px; font-size: 17px; margin-left: -15px;" mat-raised-button
            (click)="downloadOverallIndent()" color="primary">Download All Indents</button>
        </div>
      </div>
      <p style="color: red; margin-top:13px">* All numbers in the tables represents Packets (not liters)</p>
      <table class="table table-bordered" style="margin-top: -7px;">
        <tr>
          <th style="font-weight: 500;">Products </th>
          <th style="background-color: #f5f5f5;font-weight: 500;">Total</th>
          <th style="font-weight: 500;">Icustomer </th>
          <th style="font-weight: 500;" *ngFor="let booth_type of booth_types">
            {{booth_type}}
          </th>
        </tr>
        <tr *ngFor="let product of  overall_indent['products'];let product_index=index">
          <td> <b style="font-weight: 500;">{{product['name'] }}</b></td>
          <td *ngIf="overall_indent['products'][product_index]['sum'] != 0" style="background-color: #f5f5f5;">
            {{ overall_indent['products'][product_index]['sum'] }}</td>
          <td *ngIf="overall_indent['products'][product_index]['sum'] == 0" style="background-color: #f5f5f5;"></td>
          <td *ngIf="getSumDisplay(res_data['icustomer_data']['products'][product_index]['sum']) == 0"></td>
          <td *ngIf="getSumDisplay(res_data['icustomer_data']['products'][product_index]['sum']) != 0">
            {{getSumDisplay(res_data['icustomer_data']['products'][product_index]['sum'])}}</td>

          <td *ngFor="let booth_type of booth_types">
            {{res_data['booth_types'][booth_type]['product'][product_index]['sum'] }} </td>
        </tr>
      </table>
    </mat-card>
    <div *ngIf="!route_datas_loaded">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="value">
      </mat-progress-spinner>
    </div>
    <div *ngIf="route_datas_loaded">
      <div *ngFor="let route of route_wise_indent; let route_index=index">
        <mat-card>
          <div class="row" style="padding: 10px;">
            <div class="col-2"></div>
            <div class="col-3">Route : <b style="font-weight: 500;"> {{route['route_name']}}</b> <br>
              <span>
                Date :<b style="font-weight: 500;">
                  {{res_data['date'] | date: 'mediumDate' }} {{res_data['session']}} </b></span>
            </div>
            <div class="col-3">
              Active Businesses : <b style="font-weight: 500;"> {{route['business_count']}} </b><br>
              Ordered Businesses : <b style="font-weight: 500;"> {{route['order_business_count']}}
                ({{calculate_percent(route['order_business_count'], route['business_count'])}} %) </b></div>
            <div class="col-2" *ngIf="route['order_business_count'] != 0 && route['indent_status'] == 3">
              <button mat-raised-button (click)="showPdf(route['route_id'])" color="accent">Download Indent
              </button> &nbsp;<br><br>
              <button *ngIf="temp_route_dict[route['route_id']][route['temp_route_id']] == 3" mat-raised-button
                color="accent" (click)="showPdf(route['temp_route_id'])">
                Download Temp route
              </button>
            </div>
          </div>
          <table class="table table-bordered">
            <tr>
              <th></th>
              <th *ngFor="let product of  route['products'];let product_index=index" style="font-weight: 500;">
                {{product['name'] }} </th>
            </tr>
            <tr>
              <th style="font-weight: 500;">Customer</th>
              <td *ngFor="let product of  route['products'];let product_index=index">
                {{route['icustomer_products'][product_index]['sum'] }}</td>
            </tr>

            <tr>
              <th style="font-weight: 500;">Booth</th>
              <td *ngFor="let product of  route['products'];let product_index=index">
                {{route['business_products'][product_index]['sum'] }}</td>
            </tr>

            <tr>
              <th style="background-color: #f5f5f5; font-weight: 500;">Total</th>
              <td style="background-color: #f5f5f5;" *ngFor="let product of  route['products'];let product_index=index">
                {{route['products'][product_index]['sum'] }}</td>
            </tr>
          </table>

          <!-- <div style="padding: 12px; width: 100%; margin-top: -13px;" (click)="getBusinessList(route, route_index)">
            <span>
              <div class="row" style="margin-top: 10px;">
                <div class="col-1"></div>
                <div class="col"></div>
                <div class="col-3">
                  <button *ngIf="selected_index !== route_index" mat-raised-button
                    style="background-color: #efe0e0;">Display Business Wise Data <i
                      class="material-icons">keyboard_arrow_down</i></button>
                  <button *ngIf="selected_index === route_index" mat-raised-button
                    style="background-color: #efe0e0;">Hide
                    Business Wise Data <i class="material-icons">keyboard_arrow_up</i></button>
                </div>
              </div>
            </span>
          </div> -->
          <!-- <span *ngIf="selected_index === route_index">
            <span>
              <div
                style="text-align: center; margin-top: 0px; padding: 7px; border-top-left-radius: 8px; border-top-right-radius: 8px; background-color:#efe0e0 ;">
                <h3 style="font-weight: normal;">Business Wise Sale for route : <b style="font-weight: 500;">
                    {{route['route_name']}} </b></h3>
              </div>
              <table class="table table-bordered">
                <tr>
                  <th style="font-weight: 500;">Agent</th>
                  <th style="font-weight: 500;">Booth Code </th>
                  <th style="font-weight: 500;">Booth Type</th>
                  <th style="font-weight: 500;"
                    *ngFor="let product of  overall_indent['products'];let product_index=index"> {{product['name'] }}
                  </th>
                </tr>
                <tr *ngFor="let business of business_data_route_wise[route['route_id']]">
                  <td style="white-space: pre;">{{business['first_name'] | slice:0:6}}
                    {{business['last_name'] | slice:0:4 }}
                  </td>
                  <td>{{business['business_code'] }} </td>
                  <td style="white-space: pre;">{{business['business_type_name'] | slice:0:7}}</td>
                  <td *ngFor="let product of  overall_indent['products'];let product_index=index">
                    {{business['product'][product_index]['sum'] }}</td>
                </tr>
              </table>
              <hr>
            </span>
          </span> -->
        </mat-card>
        <hr>
      </div>
    </div>
  </div>
  </div>
</section>
<!--  -->
